// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1uEP-","location":"Header_location__24mmO"};